// extracted by mini-css-extract-plugin
module.exports = {"developmentList":"style_developmentList__qzi87","developmentList__wrapper":"style_developmentList__wrapper__3PiM2"};